var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Topbar", { ref: "topbar" }),
      _c(
        "div",
        {
          staticClass: "m-auto",
          staticStyle: {
            "padding-top": "30px",
            "padding-bottom": "30px",
            width: "75%",
          },
        },
        [_c("Breadcrumb", { ref: "breadcrumb", attrs: { title: "公告列表" } })],
        1
      ),
      _c(
        "div",
        {
          staticClass: "m-auto news",
          staticStyle: { width: "72%", "margin-bottom": "50px" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-100% search-box flex justify-between align-center",
            },
            [
              _c("el-input", {
                staticClass: "search-input",
                staticStyle: { width: "90%" },
                attrs: {
                  size: "large",
                  clearable: false,
                  placeholder: "请输入搜索内容",
                },
                on: { input: _vm.getDataList },
                model: {
                  value: _vm.detailsInfo.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailsInfo, "name", $$v)
                  },
                  expression: "detailsInfo.name",
                },
              }),
              _c("i", {
                staticClass: "el-icon-search",
                staticStyle: {
                  "font-size": "26px",
                  color: "#DCDFE6",
                  display: "flex",
                  "align-items": "center",
                },
                attrs: { color: "#A40000" },
                on: { click: _vm.getDataList },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex menu-list" },
            _vm._l(_vm.homeMenuList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item font-weight font-20",
                  on: {
                    click: function ($event) {
                      return _vm.handleMenu(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      style: {
                        color:
                          _vm.activeMenu.code === item.code
                            ? "#A40000"
                            : "#000",
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                  _vm.activeMenu.code === item.code
                    ? _c("i", { staticClass: "el-icon-caret-top icon" })
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { "min-height": "300px" },
              attrs: {
                "element-loading-text": "数据加载中...",
                "element-loading-background": "rgba(255, 255, 255, 0.8)",
              },
            },
            [
              _vm.newsList.length > 0
                ? _c(
                    "ul",
                    { staticClass: "size-18 ul-disc" },
                    _vm._l(_vm.newsList, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass:
                            "right-li li-before li-line-height font-18 flex align-center justify-between",
                          on: {
                            click: function ($event) {
                              return _vm.toDetails(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-1 text-omit-1 text-width" },
                            [_vm._v(_vm._s(item.name) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "font-14",
                              staticStyle: { "margin-left": "70px" },
                            },
                            [_vm._v(_vm._s(_vm._f("fmDate")(item.createTime)))]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("el-empty", { attrs: { "image-size": 200 } }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: { "justify-content": "end", "margin-top": "30px" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.detailsInfo.pageNo,
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.detailsInfo.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.dataTotal,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }